<template>
  <div class="h-toolbarBg">
    <ejs-toolbar>
      <div>
        <div class='h-inputBox'>
          <ejs-textbox placeholder='IMSI' @input='updateKeywords' @keydown.enter='keydownFunc' v-model="queryConditions.keywords"></ejs-textbox>
        </div>
        <div v-if='btns.qry'><button class="e-btn e-tbar-btn icon hero-icon hero-icon-search" :title='$t("UE.ueSearch")' @click='buttonClk("qry")'/></div>
        <div v-if='btns.detailQry'><button class="e-btn e-tbar-btn icon hero-icon hero-icon-details" :title='$t("UE.ueDetailData")' @click='buttonClk("detailQry")'/></div>
      </div>
    </ejs-toolbar>
  </div>
</template>

<script>
export default {
  name: 'UETableMenu',
  data() {
    return {
      components: {

      },
      btns: {
        qry: true,
        detailQry: true,
      },
      queryConditions: {
        keywords: '' // 模糊查询关键字
      }
    };
  },
  methods: {
    buttonClk(args) {
      this.$emit('methodEnum', args);
    },
    updateKeywords() {
      this.$emit('keywords', this.queryConditions.keywords);
    },
    keydownFunc() {
      if (this.queryConditions.keywords === '') {
        this.queryConditions.keywords = '';
        this.$emit('methodEnum', 'qry');
      } else {
        this.$emit('methodEnum', 'detailQry');
      }
    }
  }
};
</script>

<style scoped>

</style>
